module.exports = __webpack_public_path__ + "static/media/maven24.com-logo.fdeeb18d.png";